<template>
    <div class="container-fluid">
        <div class="row">
            <Card3 colClass="col-sm-12" text="true" headerTitle="true" :title="t('AddEditCatalog')">
                <div class="row g-xl-5 g-3">
                    
                <addcatalog />
                </div>
            </Card3>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
import { useI18n } from 'vue-i18n';
import { catalogAddLanguage } from '@/core/locales/catalog-list-language';

const Card3 = defineAsyncComponent(() => import("@/components/common/card/CardData3.vue"))
const addcatalog = defineAsyncComponent (() => import ("@/components/theme/ecommerce/cataloglist/catalogadd.vue"))

const { t } = useI18n({
  messages: catalogAddLanguage
})
</script>